// material-ui

// project import
import MainLayout from 'layout/MainLayout';
import AuthGuard from 'layout/AuthLayout/guard';
import LogoutDialog from 'sections/_parts/LogoutDialog';

const AuthLayout = () => (
  <AuthGuard>
    <>
      <MainLayout />
      <LogoutDialog />
    </>
  </AuthGuard>
);

export default AuthLayout;
